/* Please make changes also in next.config.mjs */

export const fallbackLng = process.env.NEXT_PUBLIC_FALLBACK_LANGUAGE as string;
export const languages: string[] = [fallbackLng as string, "en"];
export const defaultNS = "common";

export function getOptions(lng = fallbackLng, ns = defaultNS) {
  return {
    debug: false,
    supportedLngs: languages,
    fallbackLng,
    lng,
    fallbackNS: defaultNS,
    defaultNS,
    ns
  };
}
